import React, { useState } from 'react';
import './style.scss';

function SearchBox() {
  const [searchTerm, setSearchTerm] = useState('');

  const handleChange = (event) => {
    setSearchTerm(event.target.value);
  };

  return (
    // <div class="search-container">
    //   <input type="text" class="search-box" placeholder="Search...">
    //   <button type="submit" class="search-button">
    //     <i class="fa fa-search"></i>
    //   </button>
    // </div>
    <>
      <div className='search-container'>
        <input
          type="text"
          className='search-container__search-box'
          value={searchTerm}
          onChange={handleChange}
        />
        <p className='search-container__search-icon'><svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
          <path d="M17 17.5L13.2223 13.7156L17 17.5ZM15.3158 8.65789C15.3158 10.5563 14.5617 12.3769 13.2193 13.7193C11.8769 15.0617 10.0563 15.8158 8.15789 15.8158C6.2595 15.8158 4.43886 15.0617 3.0965 13.7193C1.75413 12.3769 1 10.5563 1 8.65789C1 6.7595 1.75413 4.93886 3.0965 3.5965C4.43886 2.25413 6.2595 1.5 8.15789 1.5C10.0563 1.5 11.8769 2.25413 13.2193 3.5965C14.5617 4.93886 15.3158 6.7595 15.3158 8.65789V8.65789Z" stroke="#1C262C" strokeWidth="2" strokeLinecap="round" />
        </svg></p>
      </div>
    </>
  );
}

export default SearchBox;
